import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

type SystemFields = {
  isOldIdentifer: boolean;
  isOrganonDoc: boolean;
};

type RtqDetailStore = SystemFields & {
  updateSystem: (params: SystemFields) => void;
};
const initialState: SystemFields = {
  isOldIdentifer: false,
  isOrganonDoc: false
};
const useSystemStore = create<RtqDetailStore>()(
  subscribeWithSelector(
    immer((set, get) => ({
      ...initialState,
      updateSystem(data) {
        set((state) => {
          state.isOldIdentifer = data.isOldIdentifer;
          state.isOrganonDoc = data.isOrganonDoc;
        });
      },
    }))
  )
);

export default useSystemStore;
